interface LoadingSpinnerProps {
  size?: number;
  label?: string;
  className?: string;
}

export function LoadingSpinner({ size = 16, label, className = '' }: LoadingSpinnerProps) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} role="status" aria-live="polite">
      <span
        className="inline-block animate-spin rounded-full border-2 border-orange-500/30 border-t-orange-500 motion-reduce:animate-none"
        style={{ width: size, height: size }}
        aria-hidden="true"
      />
      {label && <span className="text-sm text-[var(--color-text-secondary)]">{label}</span>}
    </span>
  );
}
